import React, { useEffect, useState } from "react";
// import Header from "./header/Header";
// import Slider from "react-slick";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
// import { NavLink } from "react-router-dom";
// import Footer from "./common/Footer";
// import Effects from "./common/Effects";
import $ from "jquery";
// import PeopleImage from "./common/PeopleImage";
// import PeopleDesc from "./common/PeopleDesc";

import { useSearchParams } from "react-router-dom";
import monuments, {
  appShareTextString,
  doRequest,
  getDeviceType,
  ShareCountApi,
  textmapping,
} from "../helper";

let desc =
  "My Tiranga selfie is ready!Together, let's celebrate India's 75th anniversary of independence by coloring our social media profiles with #HarGharTiranga";

const ImageResult = (props) => {
  // let title1 = props.shareText ? props.shareText : "";
  let title1 =
    // "Six crore Gujaratis and Shri Narendra Modi worked hard, together for over two decades to build this Gujarat. As a result, Gujarat is known as a model of development. I am proud of my Gujarat. #આ_ગુજરાત_મેં_બનાવ્યું_છે";
    "Join me on the NaMo App in advancing PM Modi's vision of 'Hamara Sankalp Viksit Bharat'. Here's my selfie with PM Modi to pledge my dedication to the mission of building a developed India, with #ViksitBharatSankalpYatra";
  const [share, setShare] = useState(false);
  const [finalImg, setFinalImg] = useState(
    props.finalResultAry && props.finalResultAry.length
      ? props.finalResultAry[0]
      : {}
  );
  const [link, setLink] = useState(
    "https://www.narendramodi.in/vikasitbharatselfie/" +
      // "https://www.narendramodi.in/aagujarat/" +
      (finalImg && finalImg.id ? finalImg.id : "")
  );
  console.log(props.finalResultAry);

  useEffect(() => {
    window.scrollTo(0, 10);
  }, []);

  useEffect(() => {
    console.log("props.finalresultarray", props.finalResultAry);
    setFinalImg(
      props.finalResultAry && props.finalResultAry.length
        ? props.finalResultAry[0]
        : {}
    );
  }, [props.finalResultAry]);

  const sharebutton = async (id) => {
    var data = {
      post_id: id,
    };
    let response = await doRequest(data, "POST", "post/addsharecount");
    // let res = await ShareCountApi(data);
    // console.log(res.data.message);
  };

  // const image = "https://res.cloudinary.com/ds4uvg1mz/image/upload/v1659962525/harghartiranga2022/xhawz8ews4ljsu0gc0qj.jpg";
  var image = "";
  // var image = finalImg.image;
  const handleNativeShare = async () => {
    console.log("handlenativeshare called");
    let title = title1;
    // let url = this.state.baseurl;

    let url = link;
    // "https://www.narendramodi.in/aagujarat/" + props.imageId;

    let data = {
      title,
      text: title,
      url: url,
    };
    console.log("data ", data);

    try {
      // if (window.location.href.indexOf("appversionandroid") > -1) {
      //   //indexOf appversion
      //   var sharelink = `appshare://text=${url} ${appShareTextString(
      //     title
      //   )}&imageurl=${image}`;
      //   // alert(sharelink);

      //   window.location.href = sharelink;
      //   console.log("sharelink", sharelink);
      // }
      if (window.location.href.indexOf("appversionios") != -1) {
        let sharelink = "";
        if (image) {
          sharelink = `appshare://?text=&imageurl=${image}}`;
        } else {
          sharelink = `appshare://?text=${encodeURIComponent(
            appShareTextString(title + "  " + url)
          )}`;
        }

        window.location.href = sharelink;
      } else if (window.location.href.indexOf("appversionandroid") != -1) {
        let sharelink = "";
        if (image) {
          sharelink = `appshare://text=&imageurl=${image}}`;
        } else {
          sharelink = `appshare://text=${appShareTextString(
            title + "  " + url
          )}`;
        }
        // alert(sharelink);

        window.location.href = sharelink;
      } else {
        if (navigator && navigator.canShare && navigator.canShare(data)) {
          image = finalImg.image;
          if (image) {
            console.log("share image..", image);
            // document.getElementById("preloader_mantra").style.display = "block";

            const mediafile = image;
            const fileSpliteString = mediafile.split(".");
            let extension = fileSpliteString[fileSpliteString.length - 1];
            const filename = `${title}_img.${extension}`;

            const response = await fetch(mediafile);
            const blob = await response.blob();
            const file = new File([blob], filename, {
              type: blob.type,
            });
            data["files"] = [file];
            console.log("Successful share ", navigator.canShare(data));
            // $(".preloader_bg").hide();
            navigator
              .share(data)
              .then(() => {
                console.log("Successfully native shared data");
              })
              .catch((error) => {
                console.log("Error native sharing", error);
                setShare(true);
                // if (ref.state.sharePopup) {
                //   ref.showSharePopup();
                // }
              });
            // document.getElementById("preloader_mantra").style.display = "none";
          } else {
            let sharemsg = "Native share only work for latest brwoser";
            console.log("sharePopup...", sharemsg);
            setShare(true);
          }
        } else {
          let sharemsg = "Native share only work for latest brwoser";
          console.log("sharePopup...", sharemsg);
          setShare(true);
        }
      }
    } catch (e) {
      setShare(true);
    }
  };

  const postOnPeopleWall = async () => {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      action: "update-mygov",
      data: {
        id: finalImg.id,
        mygov: "1",
        created: finalImg.created,
      },
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    let response = await fetch(
      "https://campaign-api.narendramodi.in/har_ghar_tiranga",
      requestOptions
    );
    response = await response.json();

    if (response._resultflag === 1) {
      alert("Done");
    } else {
      alert(response.message);
    }
  };

  console.log(props.finalResultAry, "props.finalResultAryprops.finalResultAry");

  const setFinalImage = (val, index) => {
    console.log("val ", val, "index ", index);
    $(".profile_img").css("border", "none");
    $(`.finalImage-${index}`).css("border", "2px solid blue");
    setFinalImg(val);
  };

  useEffect(() => {
    setLink(
      // "https://www.narendramodi.in/aagujarat/" +
      "https://www.narendramodi.in/vikasitbharatselfie/" +
        +(finalImg && finalImg.id ? finalImg.id : "")
    );
    console.log("finalimage ", finalImg);
  }, [finalImg]);
  useEffect(() => {
    console.log("link ", link);
  }, [link]);

  // let link = props.CloudImg;
  let iLink =
    "https://res.cloudinary.com/ds4uvg1mz/image/upload/v1659962525/harghartiranga2022/xhawz8ews4ljsu0gc0qj.jpg";
  let share_text = title1;
  let tlink = "https://twitter.com/intent/tweet?text=";
  let flink = "https://www.facebook.com/dialog/feed?app_id=445815495479697";
  let wlink = "https://api.whatsapp.com/send?text=";
  var facebookLink = `${flink}&link=${encodeURIComponent(
    link
  )}&quote=${share_text}&www.facebook.com=1`;
  var twitterLink = `${tlink} ${encodeURIComponent(
    share_text + "\n\n" + link
  )}&www.facebook.com=1`;
  var whatsappLink = `${wlink} ${encodeURIComponent(
    share_text + "  " + link
  )}&www.facebook.com=1`;

  console.log("link ", link);
  const [searchParams] = useSearchParams();
  let userid = searchParams.get("userid");

  if (userid.split("userid=").length > 1) {
    userid = userid.split("userid=")[1];
  }
  return (
    <>
      {/* <Header /> */}

      <section className="result_mar">
        <div className="container">
          <div className="wall_content_container">
            <div className="selectimage_bg">
              {/* <h5 className="text-center">
                                <a href="/" className="back_btn">
                                    <img src="/assets/images/backarrow.svg" className="" alt="" />
                                </a>
                                Monuments
                            </h5> */}
              {/* <a href={window.location.pathname} className="back_btn"> */}
              <a
                onClick={() => {
                  props.Backbutton();
                }}
                className=""
              >
                <img
                  src="/assets/images/backarrowbg.svg"
                  className="mobile_back"
                  alt=""
                />
                <img
                  src="/assets/images/backarrow.svg"
                  className="desk_back"
                  alt=""
                />
              </a>
              {/* <h4 className="text-center">{props.CloudTitle}</h4> */}

              <div className="image_result">
                {props.finalResultAry &&
                  props.finalResultAry.length > 0 &&
                  props.finalResultAry.map((val, index) => {
                    return (
                      <img
                        key={index}
                        onClick={() => setFinalImage(val, index)}
                        src={val.image}
                        className={`profile_img finalImage-${index}`}
                        alt=""
                      />
                    );
                  })}
                {/* <img src="/assets/images/flagpaint.png" className="paint_effect" alt="" /> */}
              </div>

              <div className="socail_list">
                <ul>
                  {/* {window.location.href.indexOf("appversion") > -1 ? ( */}
                  <li
                    onClick={() => {
                      try {
                        let obj = {
                          platform: getDeviceType(),
                        };
                        window.gtag("event", "Selfie Download", obj);
                      } catch (error) {}
                    }}
                  >
                    <a
                      onClick={() => {
                        let encodedurl = encodeURIComponent(
                          `${finalImg.downloadUrl}?ignore.zip`
                        );
                        let downlaodUrl = `download://?url=${encodedurl}`;
                        window.location.href = downlaodUrl;
                      }}
                      // // href={`${finalImg.downloadUrl}?ignore.zip`}
                      // href={`https://api.narendramodi.in/api/loadone?link=${finalImg.downloadUrl}?ignore.zip`}
                      // target="_blank"
                    >
                      <img
                        src="/assets/images/download.svg"
                        className="download_size"
                        alt=""
                      />{" "}
                      {textmapping("Download", props.lang)}
                    </a>
                  </li>
                  {/* // ) : (
                  //   <li */}
                  {/* //     onClick={() => {
                  //       try {
                  //         let obj = {
                  //           platform: getDeviceType(),
                  //         };
                  //         window.gtag("event", "download", obj);
                  //       } catch (error) {}
                  //     }}
                  //   >
                  //     <a
                  //       href={`https://api.narendramodi.in/api/loadone?link=${finalImg.downloadUrl}`}
                  //       target="_blank"
                  //     >
                  //       <img
                  //         src="/assets/images/download.svg"
                  //         className="download_size"
                  //         alt=""
                  //       />{" "}
                  //       {textmapping("Download", props.lang)}
                  //     </a>
                  //   </li>
                  // )} */}

                  {/* <li>
                    <NavLink to={`/uploadimage/monuments`}>Create Selfie</NavLink>
                  </li> */}
                  {share ? (
                    <>
                      <li
                        onClick={() => {
                          sharebutton(finalImg.id);
                          try {
                            let obj = {
                              platform: getDeviceType(),
                            };
                            window.gtag("event", "Selfie FB Share", obj);
                          } catch (error) {}
                        }}
                      >
                        <a href={facebookLink} target="_blank">
                          <img
                            src="/assets/images/facebook.svg"
                            className="facebook_img"
                            alt=""
                          />{" "}
                          {textmapping("Share on Facebook", props.lang)}
                        </a>
                      </li>

                      <li
                        onClick={() => {
                          try {
                            let obj = {
                              platform: getDeviceType(),
                            };
                            window.gtag("event", "Selfie Twitter Share", obj);
                          } catch (error) {}
                          sharebutton(finalImg.id);
                        }}
                      >
                        <a href={twitterLink} target="_blank">
                          <img src="/assets/images/twitter.svg" alt="" />{" "}
                          {textmapping("Share on Twitter", props.lang)}
                        </a>
                      </li>
                      <li
                        style={{ paddingBottom: "90px" }}
                        onClick={() => {
                          try {
                            let obj = {
                              platform: getDeviceType(),
                            };
                            window.gtag("event", "Selfie Whatsapp Share", obj);
                          } catch (error) {}
                          sharebutton(finalImg.id);
                        }}
                      >
                        <a href={whatsappLink} target="_blank">
                          <img src="/assets/images/whatsapp.svg" alt="" />{" "}
                          {textmapping("Share on WhatsApp", props.lang)}
                        </a>
                      </li>
                    </>
                  ) : (
                    <li style={{ cursor: "pointer" }}>
                      <a
                        onClick={() => {
                          handleNativeShare();
                        }}
                      >
                        <img
                          src="/assets/images/share.svg"
                          className="share_size"
                          alt=""
                        />{" "}
                        {textmapping("Share", props.lang)}
                      </a>
                    </li>
                  )}
                  <li style={{ cursor: "pointer", paddingBottom: "90px" }}>
                    <a href={"https://nm-4.com/scoreboard"}>
                      {textmapping("Become a Volunteer", props.lang)}
                    </a>
                  </li>
                </ul>
              </div>
              {/* {props.CloudTitle != "Monuments" && (
                <NavLink to="/uploadimage/monuments">
                  <button
                    type="button"
                    className="monumnet_btn"
                    onClick={() => {
                      props.Backbutton();
                    }}
                  >
                    <img src="/assets/images/monument.svg" alt="" /> Use this in
                    monuments
                  </button>
                </NavLink>
              )} */}
            </div>
          </div>
        </div>
      </section>

      {/* <div className="" style={{ marginBottom: "50px", marginTop: "50px" }}>
        <div className="container">
          {/* <ul className="chooseimg_list">
            {monuments?.length > 0 &&
              monuments?.map((img, index) => {
                if (index < 3) {
                  return (
                    <li>
                      <img src={img.imgId} className="rounded" alt="" />
                    </li>
                  );
                } else {
                  return <></>;
                }
              })} */}
      {/* </ul> */}
      <a
        onClick={() => {
          props.Backbutton();
        }}
        className="monument_btn"
      >
        <img
          src="/assets/images/monument.svg"
          className="monument_blue"
          alt=""
        />
        <img
          src="/assets/images/monumentwhite.svg"
          className="monument_white"
          alt=""
        />
        {textmapping("Create Selfie")}
      </a>
      {/* </div> */}

      {/* <div className="deskcontent">
        <PeopleDesc />
        <PeopleImage />
        <Footer />
        <Effects />
      </div> */}
    </>
  );
};

export default ImageResult;
